<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/swONPX/tc-custom/9781636414164.jpg?1731809219709" alt="This image is the cover for the book How to Cast Out Demons"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How to Cast Out Demons
      </h1>
      <p class="bookDescription body article font2">
        <b>The call to cast out demons is not for a select few; it is for every believer.</b><br/>  <br/> At the end of 2020, revivalist Isaiah Saldivar had a visitation from the Holy Spirit in which He told him in so many words, “Isaiah, the church is unprepared and untrained in spiritual warfare; I want you to teach on casting out demons and spiritual warfare.”<br/>  <br/> Isaiah began to emphasize deliverance training and spiritual warfare in his ministry, and what he thought would be a one-week teaching turned into eight straight months and more than sixty hours of video teachings on how to cast out demons and win the fight in the spirit. These videos have now amassed over 30 million views, and thousands have been delivered by the power of the Holy Spirit.<br/>  <br/> In this book, Isaiah helps Christians who know they should be doing deliverance but don’t know how to go about it. Exploring the seven examples in the Gospels of Jesus casting out demons, and featuring stories from Saldivar’s life and ministry, this simple guide removes the mystery and provides practical training for believers who want to follow Jesus’ example of casting out demons and healing the sick.<br/>  <br/> In these pages, Saldivar challenges readers to not ignore Satan’s kingdom and equips them to confront, resist, wrestle, stand against, and cast out. Those who are tired of sitting on the sidelines will be empowered to do the works of Jesus and be part of the most significant deliverance revival the world has ever seen.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Isaiah Saldivar
      </h2>
      
      <p class="authorDescription body article"><B>Isaiah Saldivar</B> saw his life transformed in an instant when he accepted Christ in 2011. He sensed a call to preach the gospel to every nation and today travels and preaches a message of revival and repentance, having spoken in more than five hundred churches, conferences, and other events. His attention for the last several years has been reaching people through social media, and right now his ministry reaches 6 to 8 million people each week through various platforms. He also hosts a weekly podcast called <I>Revival Lifestyle</I> that is currently in the top 1 percent of podcasts in the world. Isaiah also uploads videos every day to his YouTube channel, which currently has 860,000 subscribers. Isaiah has been married to his wife, Alyssa, for ten years and has four daughters: Justice, Journey, Harvest, and Nova.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Charisma Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c8ab8c0c